import {useUpdateAuth} from "@/contexts/AuthProvider";
import { router } from "next/client";
import axios from "@/lib/axios";
import {AxiosError, AxiosResponse} from "axios";
import {TLoginInput} from "@/types/api/Auth/Login";
import {TUser} from "@/types/user";
import {API_URL} from "@/utils/const/api";
import {URL} from "@/utils/const/url";

import {useToast} from "@/contexts/ToastProvider";

import { useRouter } from "@/navigation";
import {any} from "zod";
import axiosClient from "@/lib/axios";
import {usePost} from "@/utils/query";
import {useState} from "react";
import useAxiosClient from "@/lib/axios";
import { useCookies } from "react-cookie";

export const useLogin = () => {
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);

    const [loading, setLoading] = useState<boolean>(false);
    const {setToken} = useUpdateAuth();
    const toast = useToast();
    const router = useRouter();
    const axiosClient = useAxiosClient()

    const submitLogin = async (data: TLoginInput) => {
        setLoading(true);

        try {
            const resToken = await axiosClient.post<any, AxiosResponse<{ token: string }>, any>(
                API_URL.LOGIN,
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );


            setCookie("token", resToken.data.token, { path: "/" });
            setToken(resToken.data.token)
            window.location.reload();

        } catch (e) {

            if (e instanceof AxiosError) {
                toast.error(e?.response?.data.error ?? "Momentálně je výpadek serveru...");
            }
        } finally {
            setLoading(false)
        }

    };
    return { submitLogin, loading };

}

export default useLogin;
